import { useTranslation } from 'react-i18next'
import { Star } from 'lucide-react'
import Card from 'app/frontend/base/components/Card'
import { cn } from '@/lib/utils'

type Props = {
  isDefault: boolean
  canEdit: boolean
  disabled?: boolean
  onToggle: () => void
}

const DefaultRaidPlanToggle = ({
  isDefault,
  canEdit,
  disabled,
  onToggle,
}: Props) => {
  const { t } = useTranslation()
  const interactive = canEdit && !disabled

  return (
    <Card
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      className={cn(
        'h-10 w-36 px-3 py-0 flex items-center gap-2 shrink-0',
        interactive ? 'cursor-pointer hover:border-primary' : 'cursor-default',
      )}
      onClick={() => {
        if (!interactive) return
        onToggle()
      }}
      onKeyDown={(event) => {
        if (!interactive) return
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onToggle()
        }
      }}
    >
      <Star
        className={cn(
          'h-4 w-4 shrink-0',
          isDefault ? 'text-subscription-gold' : 'text-muted-foreground',
        )}
        fill={isDefault ? 'currentColor' : 'transparent'}
      />
      <span
        className={cn(
          'text-sm whitespace-nowrap',
          isDefault ? 'font-medium' : 'text-muted-foreground',
        )}
      >
        {isDefault
          ? t('dashboard.team.plans.default-plan')
          : t('dashboard.team.plans.set-as-default')}
      </span>
    </Card>
  )
}

export default DefaultRaidPlanToggle
